import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-video.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The SeVideo component
 * @element se-video
 */
@customElement('se-video')
export class SeVideo extends OutlineElement {
  slots = new SlotController(this, true);
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  caption: string;

  updated() {
    const video = this.shadowRoot?.querySelector('video');

    if (video) {
      const playIcon = this.shadowRoot?.querySelector('.play-btn');
      if (playIcon) {
        video.addEventListener('click', () => {
          if (video?.paused) {
            video?.setAttribute('controls', '');
            playIcon.classList.add('hidden');
          }
        });
        video.addEventListener('pause', () => {
          video?.removeAttribute('controls');
          playIcon.classList.remove('hidden');
        });
      }
    }
  }

  handleClickPlayBtn() {
    const video = this.shadowRoot?.querySelector('video') as HTMLVideoElement;
    const playIcon = this.shadowRoot?.querySelector('.play-btn') as HTMLElement;
    video.play();
    video?.setAttribute('controls', '');
    playIcon.classList.add('hidden');
  }

  render(): TemplateResult {
    const video = this.shadowRoot?.querySelector('video');
    return html`<figure class="se-video">
      <div class="video">
        ${video
          ? html`<button
              class="play-btn"
              @click="${this.handleClickPlayBtn}"
              aria-label="Play video button"
            >
              <outline-icon
                library="material"
                name="play_circle_filled"
                size="8rem"
              ></outline-icon>
            </button>`
          : ''}
        <slot name="video"></slot>
      </div>
      ${this.caption ? html`<figcaption>${this.caption}</figcaption>` : null}
    </figure>`;
  }
}
